import App from "theme/base/App"
import React from "react"
import EmptyLayout from "layout/EmptyLayout"
import AppLayout from "layout/AppLayout"
import RouteWithLayout from "layout/RouteWithLayout"
import RouteWithLogin from "layout/RouteWithLogin"
import "./theme.scss"
import "components/ShoppableImage/ShoppableImage"
import shop from "shop/shop"


// SPALTEN LISTENANSICHT
import orthoFieldConfig from "./ortho-product-list.json"

// SPALTEN PRODUKTDETAILANSICHT
import orthoFieldConfigProductDetails from "./ortho-product-details.json"
import orthoFieldConfigTranslation from "./ortho-field-config-translation.json"

import cmsStore from "stores/cmsStore"
import { setDefaultCurrency } from "components/Price/Price"
import productStore from "stores/productStore"
import LoginHandPage from "pages/LoginHandPage"
import CurrentCustomerHeader from "components/Header/CurrentCustomerHeader";
import { date } from "notie"

productStore.baseSearchUrl = "data/v2/search" // CONFIG NEW SEARCH URL


setDefaultCurrency( {currencySymbol: "EUR"} )

const getDerivedFieldname = ( value ) => {
	return orthoFieldConfigTranslation[value] || value
}

shop.config.MIN_ORDER_PENALTY_VALUE = 50
shop.config.budgetManager = true
shop.config.disable_handId_redirect = true

const mapCustomFieldData = ( data ) => {

	const configByCategoryId = {}
// DEFAULT CONFIG
	data.push( {
		"id": 2,
		"mapid": "DEFAULT",

	}, )

	data.push({
		
  

	})

	data.map( categoryConfig => {
		let columns = []

		categoryConfig.columns = columns
		configByCategoryId[categoryConfig.mapid] = categoryConfig
	} )

	return configByCategoryId
}

cmsStore.config.orthoFieldConfigByCategory = mapCustomFieldData( orthoFieldConfig )
cmsStore.config.orthoFieldProductDetailConfigByCategory = mapCustomFieldData( orthoFieldConfigProductDetails )
cmsStore.config.hideAddtionalCheckoutMetaForPowerUsers = true

// cmsStore.config.filter_defaults.view = "list"

class AppOrtho extends React.Component {

	componentWillMount() {
		cmsStore.config.filter_defaults = {
			sort: "sort"
		}
		cmsStore.config.standards = {
			sort: "sort"
		}
	}

	render() {
		return <App
			before={<div className="bg-dark"><CurrentCustomerHeader/></div>}
		>
			<RouteWithLayout layout={EmptyLayout} path={"/login/accounts"} component={LoginHandPage}/>
		</App>
	}
}

export default AppOrtho



// WEBPACK FOOTER //
// ./src/theme/demo2025/App.js